import React, { useMemo, useState, useCallback, useEffect } from 'react'
import classNames from 'classnames'

import { Avatar } from './../../../APP/COMPONENTS/Avatar';


const ChatMessage = ({ message }) => {

    const content = useMemo(() => {
        if (message.message_type == 0) {
            return (
                <div className="text">
                    { message.message }
                </div>
            )
        }

        if (message.message_type == 1) {
            return (
                <a className={ 'image' } target="_blank" href={ message.image }>
                    <img src={ message.thumb } />
                </a>
            )
        }

        if (message.message_type == 2) {
            return (
                <a className={ 'text' } target="_blank" href={ message.file }>
                    Файл
                </a>
            )
        }

        return null;
    }, [message])

    return (
        <div className={ classNames('bubbleHolder', {
            ['we']: message.direction == 1
        }) }>
            <div className={ 'bubble' }>
                { message.direction == 1 && message.manager ?
                    <div className={ 'managerData' }>
                        <Avatar src={ message.manager.image } size="25px" />
                        <div className={ 'managerName' }>
                            { message.manager.readable_name }
                        </div>
                    </div>
                    : null
                }

                { content }

                <div className={ 'created' }>
                    { message.ru_created }
                </div>
            </div>
        </div>
    )
}

export default ChatMessage
